import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rental-custom-pickup-slots',
  templateUrl: './rental-custom-pickup-slots.component.html',
  styleUrls: ['./rental-custom-pickup-slots.component.scss'],
})
export class RentalCustomPickupSlotsComponent implements OnInit {
  @Input() configuration;
  public pickupSlots: any = [];
  public loadingPickupSlots: boolean = false;
  public showCustomPickupSlot: boolean = false;
  public deleting: boolean = false;
  public panelData: any = {};

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.getOverridePickupSlots();
  }

  getOverridePickupSlots() {
    this.loadingPickupSlots = true;
    this.rentalsService
      .getOverridePickupSlots(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.pickupSlots = res;
          this.loadingPickupSlots = false;
        },
        (err) => {
          this.loadingPickupSlots = false;
        },
      );
  }

  dayOfWeek(val) {
    switch (val) {
      case 0:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.sunday',
        );
      case 1:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.monday',
        );
      case 2:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.tuesday',
        );
      case 3:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.wednesday',
        );
      case 4:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.thursday',
        );
      case 5:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.friday',
        );
      case 6:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.saturday',
        );
    }
  }

  canAddOverrideSlots() {
    return (
      this.configuration &&
      this.configuration.defaultStoreTimes &&
      this.configuration.defaultStoreTimes.filter((x: any) => {
        return x.isWorking;
      }).length > 0
    );
  }

  closePanel(data) {
    this.showCustomPickupSlot = false;
    this.pickupSlots = data;
  }

  addNew() {
    this.panelData = {
      defaultPartnerID: this.helpersService.getPartnerId(),
    };
    this.showCustomPickupSlot = true;
  }

  editRecord(item) {
    this.panelData = JSON.parse(JSON.stringify(item));
    this.showCustomPickupSlot = true;
  }

  deleteRecord(item, index) {
    this.deleting = true;
    this.pickupSlots.splice(index, 1);
    this.rentalsService
      .deleteOverridePickupSlot(this.helpersService.getPartnerId(), item.id)
      .subscribe(
        (res) => {
          this.pickupSlots = res;
          this.deleting = false;
        },
        (err) => {
          this.deleting = false;
          this.getOverridePickupSlots();
        },
      );
  }
}
